function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNav(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 23,
    viewBox: "0 0 21 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M16.5837 8.11607C18.5487 8.11607 20.1417 6.52308 20.1417 4.55803C20.1417 2.59299 18.5487 1 16.5837 1C14.6186 1 13.0256 2.59299 13.0256 4.55803C13.0256 6.52308 14.6186 8.11607 16.5837 8.11607Z",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.55804 8.11607C6.52309 8.11607 8.11606 6.52308 8.11606 4.55803C8.11606 2.59299 6.52309 1 4.55804 1C2.593 1 1 2.59299 1 4.55803C1 6.52308 2.593 8.11607 4.55804 8.11607Z",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5837 21.9064C18.5487 21.9064 20.1417 20.3134 20.1417 18.3483C20.1417 16.3833 18.5487 14.7903 16.5837 14.7903C14.6186 14.7903 13.0256 16.3833 13.0256 18.3483C13.0256 20.3134 14.6186 21.9064 16.5837 21.9064Z",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.55804 21.9064C6.52309 21.9064 8.11606 20.3134 8.11606 18.3483C8.11606 16.3833 6.52309 14.7903 4.55804 14.7903C2.593 14.7903 1 16.3833 1 18.3483C1 20.3134 2.593 21.9064 4.55804 21.9064Z",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNav);
export default __webpack_public_path__ + "static/media/nav.0f5fad2f644971ae234a82973ac80858.svg";
export { ForwardRef as ReactComponent };